
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gX1TdOgeptF_2YvmWEQqdOq_45lKgsWmTJDRYZNcZNamKoMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexzP7XNG9SyTAuU7959EzYEAZl4AlOQgXcDOdxx_54UwIMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchjtfOCv6u8373fZIj4NV0Lp_LrmuLClwy9jDHOamHwrkMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index2lcWnb2yQLh207xS0qZTYEgc8XnjbwyfQD1wQ6fcX8oMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93DQaVVlB4hXvKI_45iDEoG71gKMkwPGHuCRixj8zBm7YfMMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexFxAifAk71W1r9ysp9DdEnlCqwAM20iPE8xBIyg6gLw0Meta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93rP2E42eLLBhCN3MW9XNC4QcKvUTCoO70TIzWLA2GbE8Meta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexZtrMOh58ir0PFVfd8GzLGbc4YyRNMBCBgyrZyVvoQ0IMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93ZWpE_45WhlYDU6XwpiRf0CyknhiYBj4xqYeI7p_M45_45K0Meta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexN9HtnT6w_45wun6RezntTEv2qh_NAfdGXpRkojvYcb8MEMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexVXU7aI9rlU3dT5Xx_uCijFH1Gmd5cRrN8X8SNn2RJYgMeta } from "/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexFxAifAk71W1r9ysp9DdEnlCqwAM20iPE8xBIyg6gLw0Meta || {},
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexZtrMOh58ir0PFVfd8GzLGbc4YyRNMBCBgyrZyVvoQ0IMeta || {},
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexN9HtnT6w_45wun6RezntTEv2qh_NAfdGXpRkojvYcb8MEMeta || {},
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexVXU7aI9rlU3dT5Xx_uCijFH1Gmd5cRrN8X8SNn2RJYgMeta || {},
    component: () => import("/codebuild/output/src1928693444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]